import { supabase } from "./client";
import { normalizeWaiterAssistanceConfig } from "../local/waiterAssistance";

const assertReady = (branchId) => {
  if (!supabase || !branchId) {
    throw new Error("No se pudo conectar con la sucursal para guardar las opciones del mozo.");
  }
};

const configError = (error, action) => {
  if (error?.code === "42703" || error?.code === "PGRST204") {
    return new Error("No se pudo sincronizar: falta aplicar waiter_assistance_config_patch.sql en Supabase.");
  }
  return new Error(`No se pudo ${action} las opciones del mozo. ${error?.message || "Intenta nuevamente."}`);
};

export const loadBranchWaiterAssistance = async (branchId) => {
  assertReady(branchId);
  const { data, error } = await supabase.from("branch_settings")
    .select("waiter_assistance_config").eq("branch_id", branchId).maybeSingle();
  if (error) throw configError(error, "cargar");
  // Null means this branch has not published its old browser-only settings yet.
  return data?.waiter_assistance_config == null ? null :
    normalizeWaiterAssistanceConfig(data.waiter_assistance_config);
};

export const saveBranchWaiterAssistance = async (branchId, payload) => {
  assertReady(branchId);
  const config = normalizeWaiterAssistanceConfig(payload);
  const { data, error } = await supabase.from("branch_settings")
    .upsert({ branch_id: branchId, waiter_assistance_config: config }, { onConflict: "branch_id" })
    .select("waiter_assistance_config").single();
  if (error) throw configError(error, "guardar");
  if (!data?.waiter_assistance_config) throw new Error("No se pudo confirmar el guardado de las opciones del mozo.");
  return normalizeWaiterAssistanceConfig(data.waiter_assistance_config);
};
